<script setup lang="ts">
import { useAttrs, computed } from "vue";

type Props = {
  tag?: string;
  rounded?: "sm" | "md" | "lg" | "none";
};
const props = withDefaults(defineProps<Props>(), {
  tag: "div",
  rounded: "sm",
});

const attrs = useAttrs();

const isClickable = computed(() => !!attrs.onClick);

const tag = computed(() => props.tag);
const roundedClass = computed(() => {
  const map = {
    none: "",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
  };
  return map[props.rounded];
});
</script>
<template>
  <component
    :is="tag"
    class="bg-gray-50 dark:bg-primary-900 border border-gray-100 dark:border-primary-800 px-4 py-6 lg:p-6 flex flex-col"
    :class="[
      roundedClass,
      {
        'cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300 hover:border-primary-400 dark:hover:border-primary-600':
          isClickable,
      },
    ]"
  >
    <slot />
  </component>
</template>
